import React from 'react';
import './seaflashbot.css';

/**
 * SeaflashBot floating action button.
 * Drop-in replacement for the old button — same props interface.
 *
 * Usage:
 *   <SeaflashBotButton onClick={() => setIsOpen(true)} />
 */

// ── AI Chat Icon ───────────────────────────────────────────────────────────
// Concept: Rounded chat bubble with an AI neural spark inside — clean, modern,
// instantly recognisable as "AI assistant / chat"
const MaritimeAIIcon = () => (
  <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">

    {/* ── Outer chat bubble ── */}
    <rect x="2" y="2" width="28" height="24" rx="7" ry="7"
      fill="rgba(255,255,255,0.15)"
      stroke="rgba(255,255,255,0.5)"
      strokeWidth="1.5"
    />

    {/* Bubble tail */}
    <path
      d="M8 26 L5 32 L15 28"
      fill="rgba(255,255,255,0.15)"
      stroke="rgba(255,255,255,0.5)"
      strokeWidth="1.5"
      strokeLinejoin="round"
      strokeLinecap="round"
    />

    {/* ── AI 4-point star spark — centered in bubble ── */}
    {/* Outer glow */}
    <circle cx="16" cy="13" r="7"
      fill="rgba(255,255,255,0.08)"
    />
    {/* Star — sharp 4-point diamond cross */}
    <path
      d="M16 6.5
         C16.3 9.8 17.2 11.7 19.5 13
         C17.2 14.3 16.3 16.2 16 19.5
         C15.7 16.2 14.8 14.3 12.5 13
         C14.8 11.7 15.7 9.8 16 6.5 Z"
      fill="white"
      opacity="0.95"
    />
    {/* Small secondary diagonal cross — adds the "AI sparkle" feel */}
    <path
      d="M16 8.5
         C16.15 10.8 16.9 12 18.5 13
         C16.9 14 16.15 15.2 16 17.5
         C15.85 15.2 15.1 14 13.5 13
         C15.1 12 15.85 10.8 16 8.5 Z"
      fill="rgba(163,247,224,0.7)"
    />
    {/* Center dot */}
    <circle cx="16" cy="13" r="1.5" fill="white" />

    {/* ── Three dot indicators (bottom of bubble — "thinking") ── */}
    <circle cx="9"  cy="20" r="1.2" fill="rgba(255,255,255,0.5)" />
    <circle cx="13" cy="20" r="1.2" fill="rgba(255,255,255,0.65)" />
    <circle cx="17" cy="20" r="1.2" fill="rgba(255,255,255,0.5)" />

  </svg>
);

// ── Component ──────────────────────────────────────────────────────────────
const SeaflashBotButton = ({ onClick }) => {
  return (
    <div className="seaflashbot-container">
      {/* Tooltip */}
      <div className="sfb-tooltip">AI Maritime Assistant</div>

      {/* Pulse rings (behind button) */}
      <div style={{ position: 'relative', height: 56, display: 'flex', justifyContent: 'flex-end' }}>
        <div className="sfb-rings">
          <div className="sfb-ring" />
          <div className="sfb-ring" />
          <div className="sfb-ring" />
        </div>

        {/* Main button */}
        <button className="sfb-btn" onClick={onClick} aria-label="Open SeaflashBot">
          <div className="sfb-icon">
            <MaritimeAIIcon />
            {/* Online indicator dot */}
            <div className="sfb-ai-dot" />
          </div>
          <span className="sfb-label">SeaflashBot</span>
        </button>
      </div>
    </div>
  );
};

export default SeaflashBotButton;